const prod = {
    url: {
     API_URL: 'https://vp-api.blinkay.app/api/zoneoptions'     
    }
};
const dev = {
    url: {
     API_URL: 'https://vp-api.blinkay.app/api/zoneoptions'     
    //  API_URL: 'https://localhost:44386/api/zoneoptions'
    }
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;